import React from 'react';
import { Grid } from '@mui/material';
import { languageProgress } from './data';
import './Skillsbar.css';

const Skillsbar = () => {
  return (
    <Grid container justify="center" spacing={4}>
      {languageProgress.map((language) => {
        const { id, name, value } = language;
        return (
          <Grid key={id} item xs={12} sm={12} md={6} lg={6}>
            <div className="skillsbar">
              <span className="skillsbar__name" key={id}>
                {name}
              </span>
              <span className="skillsbar__value">{value}%</span>
            </div>
            <div className="skillsbar__percent">
              <div
                className="skillsbar__progress"
                style={{ width: `${value}%` }}
              ></div>
            </div>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Skillsbar;
